export class PublicArea {

  PublicAreaId :number;
  Subscriber:string;
  HotelId: number;
  AreaCode : string;
  AreaName : string;
  Active : boolean;

}